import { InjectionToken } from '@angular/core';
import { LatLng } from 'leaflet';

/**
 * Handler für WMS-Feld-Mapping.
 * Ermöglicht dem WmsDataService, Dokumente zu befüllen ohne das Datenmodell zu kennen.
 */
export interface WmsFieldMappingHandler<T> {
	getCoordinates(document: T): LatLng;
	shouldFetchKlimastufe(document: T): boolean;
	setKlimastufeData(document: T, data: { klimastufe?: string }): void;
	shouldFetchForstadresse(document: T): boolean;
	setForstadresseData(document: T, data: {
		abt?: string;
		ua?: string;
		tf?: string;
		fa_txt?: string;
		fr_txt?: string;
		schl_gis?: string;
	}): void;
	shouldFetchKatasteradresse(document: T): boolean;
	setKatasteradresseData(document: T, data: {
		gmkname?: string;
		flurnr?: string;
		gmknr?: string;
		'cp:label'?: string;
	}): void;
	shouldFetchWuchsgebiet(document: T): boolean;
	setWuchsgebietData(document: T, data: { bez_wg_bu?: string; bez_wb_bu?: string }): void;
	/** Optional: Speichert das Dokument nach WMS-Datenanreicherung in die DB */
	saveDocument?(document: T): void;
}

export const WMS_FIELD_MAPPING_HANDLER = new InjectionToken<WmsFieldMappingHandler<any>>(
	'WMS_FIELD_MAPPING_HANDLER'
);
